import { ref, Ref } from 'vue';
import { PositionEditResult } from '../utils/PositionEditResult';

class ProjectContext {
  public enablePositionEditor: Ref<boolean> = ref(false);
  public nodeList: Ref<NodeList> = ref(null);

  public positionEditResult: Ref<PositionEditResult[]> = ref([]);
}
export const projectContext = new ProjectContext();
